<template>
  <div class="card-container">
    <common-el-form
      :model="formModel"
      :rules="formRules"
      :submitData="submitData"
      @success="onSuccess"
      @cancel="onCancel"
      submit-btn-text="提交"
      failTitle="提交失败"
      loadingText="提交中..."
      :submitService="submitService"
      ref="formModel"
      :showButton="false"
      :SubmitButton="true"
    >
      <el-button
        type="info"
        icon="el-icon-back"
        circle
        @click="returnPage"
        style="margin: 0px 0px 10px 0px"
        maxlength="8"
        show-word-limit
      ></el-button>
      <el-form-item label="商品别名" prop="goodsAlias">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.goodsAlias"
          placeholder="请输入商品别名"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品类型" prop="goodsType">
        <el-select
          v-model="formModel.goodsType"
          @change="selectChanged(1)"
          style="width: 400px"
        >
          <el-option
            v-for="item in GoodsTypes"
            :key="item.id"
            :label="item.name"
            :value="item.id + ''"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类别" prop="goodsCategory">
        <el-select
          v-model="formModel.goodsCategory"
          @change="shoptypes"
          style="width: 400px"
        >
          <el-option
            v-for="item in categoryname"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称" prop="goodsId">
        <el-select v-model="formModel.goodsId" style="width: 400px">
          <el-option
            v-for="item in GoodsListAll"
            :key="item.id"
            :label="item.goodsName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="会员级别"
        prop="extraInfo"
        v-if="formModel.showType == 1"
      >
        <el-select v-model="formModel.extraInfo" style="width: 400px">
          <el-option
            v-for="item in levelList"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="卓越级别"
        prop="extraInfo"
        v-if="formModel.showType == 2"
      >
        <el-select v-model="formModel.extraInfo" style="width: 400px">
          <el-option
            v-for="item in seatList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所需积分" prop="needIntegral">
        <el-input-number
          v-model="formModel.needIntegral"
          :min="0"
          :max="999999999"
          :step="1"
          :precision="0"
          :controls="false"
          placeholder="请输入所需积分"
          style="width: 400px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="数量" prop="startNumber" v-if="shopName == '通证'">
        <el-input
          type="text"
          maxlength="10"
          v-model="formModel.startNumber"
          placeholder="请输入数量"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="兑换金额"
        prop="conversionMoney"
        v-if="shopName == '现金'"
      >
        <el-input-number
          v-model="formModel.conversionMoney"
          :min="0"
          :max="999999999"
          :step="1"
          :precision="2"
          :controls="false"
          placeholder="请输入兑换金额"
          style="width: 400px"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="库存"
        prop="conversionCount"
        v-if="shopName == '现金'"
      >
        <el-input
          type="text"
          maxlength="10"
          v-model="formModel.conversionCount"
          placeholder="请输入库存数量"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品图片" prop="pictureUrl">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl + '8883/picture/upload'"
          :data="commonParams"
          name="picture"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="formModel.pictureUrl"
            :src="formModel.pictureUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="商品内容详情" prop="textAlias">
        <div style="display: flex">
          <my-editor
            ref="myEditor"
            v-model="formModel.textAlias"
            @change="textAlias(formModel.textAlias)"
          ></my-editor>
          <div class="editorValue">
            <div class="text" v-html="jiexiText"></div>
          </div>
        </div>
      </el-form-item>
    </common-el-form>
  </div>
</template>

<script>
import CommonElForm from "@/components/common/CommonElForm";
import MyEditor from "./MyEditor";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import {
  encrypt,
  urlEncode,
  objKeySort,
  debounce,
} from "common/js/common-utils";
import MallService from "service/MallService";
import MemberLevelService from "service/MemberLevelService";
import privateKey from "service/constant/privateKey";
import Server from "common/conf/Server";
import StorageService from "store/interfaces";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "platformintroductionedit",
  components: {
    CommonElForm,
    MyEditor,
  },
  data() {
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value);
      if (!boolean) {
        this.formRules.conversionCount[0].message = "请输入正整数";
        this.this.formModel.conversionCount = undefined;
      }
    };
    return {
      jiexiText: "",
      categoryname: [],
      GoodsTypes: [],
      GoodsListAll: [],
      shopName: "",
      levelList: [],
      seatList: [],
      organInfo: {},
      formModel: {
        goodsCategory: "",
        // goodsDesc: "",
        goodsType: "",
        needIntegral: undefined,
        pictureUrl: "",
        goodsId: "",
        extraInfo: "",
        showType: "",
        startNumber: undefined,
        conversionMoney: undefined,
        conversionCount: undefined,

        // name: "",
        goodsAlias: "",
        textAlias: "",
      },
      formRules: {
        goodsId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // console.log(value);
              if (!value) {
                callback(new Error("请选择商品名称"));
              } else {
                this.GoodsListAll.forEach((item) => {
                  if (item.id == value) {
                    this.formModel.showType = item.showType;
                    // if (
                    //   this.formModel.showType == 1 ||
                    //   this.formModel.showType == 2
                    // ) {
                    //   this.formRules.extraInfo[0].required = true;
                    // } else {
                    //   this.formRules.extraInfo[0].required = false;
                    // }
                  }
                });

                return callback();
              }
            },
          },
        ],
        goodsAlias: [
          {
            required: true,
            message: "请输入商品别名",
          },
        ],
        goodsCategory: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入商品类别"));
              } else {
                this.categoryname.forEach((item) => {
                  if (value == item.id) {
                    this.shopName = item.categoryName;
                    if (this.shopName == "通证") {
                      this.formRules.startNumber[0].required = true; //数量
                    } else {
                      this.formRules.startNumber[0].required = false;
                    }
                    if (this.shopName == "现金") {
                      this.formRules.conversionMoney[0].required = true; //现金
                      this.formRules.conversionCount[0].required = true; //库存
                    } else {
                      this.formRules.conversionMoney[0].required = false;
                      this.formRules.conversionCount[0].required = false;
                    }
                  }
                });
                return callback();
              }
            },
          },
        ],
        goodsType: [
          {
            required: true,
            message: "请输入商品类型",
          },
        ],
        needIntegral: [
          {
            required: true,
            message: "请输入所需积分",
          },
        ],
        pictureUrl: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.formModel.pictureUrl) {
                callback(new Error("请选择"));
              } else {
                return callback();
              }
            },
          },
        ],
        // extraInfo: [
        //   {
        //     required: false,
        //     validator: (rule, value, callback) => {
        //       if (!value) {
        //         callback(
        //           // new Error(
        //           //   `请选择${
        //           //     this.formModel.showType == 1 ? "会员" : "卓越"
        //           //   }级别`
        //           // )
        //           new Error("请选择")
        //         );
        //       } else {
        //         return callback();
        //       }
        //     },
        //   },
        // ],
        startNumber: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入商品数量"));
              } else {
                return callback();
              }
            },
          },
        ],
        conversionMoney: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入兑换金额"));
              } else {
                return callback();
              }
            },
          },
        ],
        conversionCount: [
          {
            required: false,
            validator: blurText,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入库存数量"));
              } else {
                return callback();
              }
            },
          },
        ],
      },
      uploadUrl: Server[process.env.NODE_ENV],
    };
  },
  mounted() {
    this.organInfo = JSON.parse(this.$route.params.fuID);
    if (this.$route.params.item) {
      this.formModel = JSON.parse(this.$route.params.item);
      this.$refs.formModel.validateField("pictureUrl");
      this.formModel.textAlias = this.formModel.goodsDesc;
      this.formModel.pictureUrl = this.formModel.pictureUrl;
      this.getCategoryname(
        this.formModel.goodsType,
        this.formModel.goodsCategory
      );
    }
    this.getGoodsTypes();
    this.getLevelList();
    this.getSeatList();
  },
  computed: {
    submitService() {
      return this.formModel.id
        ? MallService.publicplatoongoodsEdit
        : MallService.publicplatoongoodsAdd;
    },
    submitData() {
      const params = {
        goodsAlias: this.formModel.goodsAlias,
        startNumber: this.formModel.startNumber,
        conversionCount: this.formModel.conversionCount,
        conversionMoney: this.formModel.conversionMoney,
        goodsCategory: this.formModel.goodsCategory,
        // goodsDesc: this.jiexiText,
        goodsType: this.formModel.goodsType,
        goodsId: this.formModel.goodsId,
        needIntegral: this.formModel.needIntegral,
        pictureUrl: this.formModel.pictureUrl,
        showType: this.formModel.showType,
        extraInfo: this.formModel.extraInfo,
        simpleTatId: this.organInfo.id,
      };
      let newContent = this.jiexiText.replace(
        /<img[^>]*>/gi,
        function (match, capture) {
          match = match
            .replace(/style="[^"]+"/gi, "")
            .replace(/style='[^']+'/gi, "");
          match = match
            .replace(/width="[^"]+"/gi, "")
            .replace(/width='[^']+'/gi, "");
          match = match
            .replace(/height="[^"]+"/gi, "")
            .replace(/height='[^']+'/gi, "");
          return match;
        }
      );
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      newContent = newContent.replace(/<br[^>]*\/>/gi, "");
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="width:100%;height:auto;"'
      );
      params.goodsDesc = newContent;
      if (this.formModel.id) {
        params.id = this.formModel.id;
      }
      return params;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "reloadPage"]),
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  watch: {
    //商品类型
    "formModel.goodsType"(val, oldVal) {
      this.getCategoryname(val, this.formModel.goodsCategory);
    },
    "formModel.goodsCategory"(val, oldVal) {
      this.getCategoryname(this.formModel.goodsType, val);
      this.getGoodsListAll(val);
    },
    "formModel.goodsId"(val, oldVal) {
      // this.formModel.goodsAlias = "";
      this.formModel.extraInfo = "";
    },
    "formModel.extraInfo"(val, oldVal) {
      // if (this.formModel.showType == 1) {
      //   this.formModel.goodsAlias = this.levelList.find(
      //     (item) => item.id == val
      //   ).levelName;
      // }
      // if (this.formModel.showType == 2) {
      //   this.formModel.goodsAlias = this.seatList.find(
      //     (item) => item.id == val
      //   ).name;
      // }
    },
  },
  methods: {
    onSuccess(res) {
      this.doCheck(res, (res) => {
        this.isReloadPage(true);
        this.showSuccess(res.respMsg);
        this.onCancel();
      });
    },
    onCancel() {
      this.$router.back();
    },
    getSeatList() {
      this.doLoad(
        MemberLevelService.listNoPage,
        {
          tatSimpleId: this.organInfo.id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.seatList = result;
          });
        },
        "信息获取失败"
      );
    },
    getLevelList() {
      this.doLoad(
        MemberLevelService.select,
        {
          tatSimpleId: this.organInfo.id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.levelList = result.memLevelManageList;
          });
        },
        "信息获取失败"
      );
    },
    getCategoryname(val, goodsCategory) {
      this.doLoad(
        MallService.categoryname,
        {
          commodityType: val,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.categoryname = res.contents;
            this.categoryname.forEach((item) => {
              if (goodsCategory == item.id) {
                this.shopName = item.categoryName;
              }
            });
          });
        },
        "操作失败"
      );
    },
    getGoodsTypes() {
      this.doLoad(
        MallService.goodsDictGoodsTypes,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.GoodsTypes = res.contents;
          });
        },
        "操作失败"
      );
    },
    getGoodsListAll(val) {
      this.doLoad(
        MallService.storeGoodsListAll,
        {
          goodsCategory: val,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.GoodsListAll = res.contents;
          });
        },
        "操作失败"
      );
    },
    shoptypes(val) {
      this.formModel.goodsId = ""; //商品名称
      this.formModel.startNumber = undefined; //数量
      this.formModel.conversionMoney = undefined; //兑换金额
      this.formModel.conversionCount = undefined; //库存
    },
    selectChanged(val) {
      if (val == 1) {
        this.formModel.goodsCategory = ""; //商品类别
        this.formModel.goodsId = ""; //商品名称
        this.formModel.showType = "";
      }
    },
    textAlias(val) {
      let newContent = val.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      // newContent = newContent.replace(/<br[^>]*\/>/gi, "");
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="width:100%;height:auto;"'
      );
      this.jiexiText = newContent;
      // this.jiexiText = val;
    },
    returnPage() {
      this.$router.go(-1);
    },

    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.formModel.pictureUrl = res.contents;
        this.$refs.formModel.validateField("pictureUrl");
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    ...mapActions({
      isReloadPage: StorageService.Reload.page,
    }),
  },
};
</script>

<style scoped>
.editorValue {
  margin: 0px 0px 0px 60px;
  width: 600px;
  height: 800px;
  overflow: hidden;
  overflow-y: auto;
  border: 1px solid #e6e6e6;
  padding: 15px;
}
.editorValue .name {
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 15px;
}
.editorValue .text {
  width: 100%;
  /* white-space: pre-wrap; */
}
/* .editorValue >>> img {
  width: 100%;
} */
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/PlatformIntroductionEdit.vue